<template>
    <div>
        <wap-header></wap-header>

        <div class="wap-OP">
            <div class="wapBox">
                <div class="wap-select-header">
                    <div class="wapLeft">
                        <div :class="tabIndex==1?'active':''"  @click="btn_tab(1)">
                            <span>生产资源合作</span>
                        </div>
                        <div :class="tabIndex==2?'active':''"  @click="btn_tab(2)">
                            <span>产品合作</span>
                        </div>
                    </div>
                    <div class="right">
                        <img :src="imgUrl">
                    </div>
                </div>
                <div class="wap-cooperation-box" v-if="tabIndex==1" style="margin-bottom:30px;">
                    <span class="wap-introduce">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆市斯普瑞科技有限责任公司在新能源、新材料和功能化学品领领域储备了大量的产品，拥有先进的生产技术和可靠的市场渠道，如果您的工厂位于化工园区，有富余或闲置的土地、厂房、车间或设备等生产资源，希望得到更合理的利用或者发展新产品，您可以联系我们进行合作。有如下合作方式可以供您选择：</span>
                    <div class="li">
                        <h4>1.股权合作</h4>
                        <span>双方各自投入所拥有的生产运营资源，协商确定权益分配比例，共同配置缺省的生产运营资源，共同管理和运营，按照权益分配比例分享收益。</span>
                    </div>
                    <div class="li">
                        <h4>2.租赁合作</h4>
                        <span>您将您富余或闲置的生产资源租赁给我们，按照协商确定的价格收取租赁费用，我们自主组织生产和运营。</span>
                    </div>
                    <div class="li">
                        <h4>3.代工生产合作</h4>
                        <span>我们提供工艺技术，协助您开展工程建设和生产调试，直至能够稳定的生产出合格产品。我们负责原料采购和产品销售，您负责生产，根据产量和原料消耗结算生产费用。</span>
                    </div>
                    <div class="li lastText">
                        <h4>4.技术工程服务合作</h4>
                        <span>如果您只想发展新产品，希望能够自主独立运营，我们也可以为您提供从工艺技术转让、工程建设、生产调试到市场开发的一整套服务，让您的发展无后顾之忧。</span>
                    </div>
                    <div class="li">
                        <span style="margin-bottom:10px;display: block;">如果您有合作意愿，请联系我们：</span>
                        <span>冯先生：<a href="tel:18623331236">18623331236</a><br>&nbsp;&nbsp;&nbsp;邮箱：swengin@163.com</span><br><br>
                        <span>杨先生：<a href="tel:13627659255">13627659255</a><br>&nbsp;&nbsp;&nbsp;邮箱：13627659255@163.com</span><br><br>
                        <span>郑先生：<a href="tel:18623567171">18623567171</a><br>&nbsp;&nbsp;&nbsp;邮箱：zhengyi159357258@163.com</span>
                    </div>
                </div>
                <div class="wap-cooperation-box" v-if="tabIndex==2" style="margin-bottom:30px;">
                    <span class="wap-introduce">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆市斯普瑞科技有限责任公司聚焦于技术开发和市场运营，生产上与多家质量管理体系完善、安全环保设施完备的具有生产资源优势的生产企业建立了长期稳定的合作关系，可以为客户提供以下产品的代工生产服务：</span>
                    <div class="li">
                        <h4>1.氯化产品</h4>
                        <span>氯化是化合物的分子中引入氯原子的反应，氯化反应有取代氯化、加成氯化、置换氯化、氯氧化等类型。</span>
                        <span>我们的合作工厂有釜式、塔式、管式和环管式等多种氯化反应设备和完备的后处理设施，可以为您提供多种氯化产品代工生产服务。</span>
                    </div>
                    <div class="li">
                        <h4>2.氰化加成产品</h4>
                        <span>醛、酮、环氧和双键化合物与氢氰酸加成可以制备多种多样的中间体，广泛应用于医药、农药、新材料等功能性化学品领域。</span>
                        <span>我们的合作工厂有高纯的液体氢氰酸和气体氢氰酸、有连续流和固定床催化等多种氰化加成反应设备以及完备的公用工程和良好的储运设施，可以为您提供定制化的氰化加成产品代工生产服务。</span>
                    </div>
                    <div class="li lastText">
                        <h4>3.氯甲基化产品</h4>
                        <span>在缩合剂（氯化剂）存在下，氯甲基化剂（甲醛和氯化氢）与芳香化合物作用，在环上引入氯甲基的反应为氯甲基化反应。苯、萘、蒽、噻吩、呋喃等和它们的衍生物都能发生氯甲基化反应，制备用于多种用途的有机中间体。</span>
                        <span>我们的合作工厂有优良的原辅材料配套，有完善的三废资源化利用设施，有高效的生产管理团队，非常乐意为您提供定制化的氯甲基化产品代工生产服务。</span>
                    </div>
                    <div class="li">
                        <span style="margin-bottom:10px;display: block;">如果您有合作意愿，请联系我们：</span>
                        <span>冯先生：<a href="tel:18623331236">18623331236</a><br>&nbsp;&nbsp;&nbsp;邮箱：swengin@163.com</span><br><br>
                        <span>杨先生：<a href="tel:13627659255">13627659255</a><br>&nbsp;&nbsp;&nbsp;邮箱：13627659255@163.com</span><br><br>
                        <span>郑先生：<a href="tel:18623567171">18623567171</a><br>&nbsp;&nbsp;&nbsp;邮箱：zhengyi159357258@163.com</span>
                    </div>
                </div>
            </div>
        </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    import header1 from '@/assets/image/cooperation/header1-1.png'
    import header2 from '@/assets/image/cooperation/header1-2.png'

    export default {
        name: "OPWap",
        components: {wapHeader, wapFooter},
        data() {
            return {
                tabIndex: 1,
                imgUrl: '',
                list: []
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.tabIndex = Number(this.$route.query.type);
                }
                switch (this.tabIndex) {
                    case 1:
                        this.imgUrl = header1;
                        break
                    case 2:
                        this.imgUrl = header2;
                        break
                }
            }
        },
        mounted() {
            if (this.$route.query.type) {
                this.tabIndex = Number(this.$route.query.type);

            }
            switch (this.tabIndex) {
                case 1:
                    this.imgUrl = header1
                    break
                case 2:
                    this.imgUrl = header2
                    break
            }
        },
        methods: {
            btn_tab(index) {
                this.tabIndex = index;
                switch (this.tabIndex) {
                    case 1:
                        this.imgUrl = header1
                        break
                    case 2:
                        this.imgUrl = header2
                        break
                }
            }
        }
    }
</script>

<style scoped>
    .wap-OP{
        width:390px;
        height:100%;
        margin:55px auto 0;
    }
    .wap-OP .wapBox{
        width:355px;
        height:100%;
        margin:0 auto 0;
    }
    .wap-select-header .right img{
        width:355px;
        height:106px;
        margin:0 auto;
        border-radius: 10px;
    }
    .wap-select-header .wapLeft div{
        width: 50%;
        height: 46px;
        line-height: 46px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px 10px 0 0;
    }
    .wap-select-header .wapLeft{
        width: 355px;
        height: 46px;
        margin: 0 auto 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #007ED2;
        border-radius: 10px 10px 0 0;
    }
    .wap-select-header .wapLeft .active{
        background: rgba(0, 0, 0, 0.42);
        border-radius: 10px 10px 0 0;
    }
    .wap-cooperation-box{
        font-size:14px;
        line-height: 20px;
    }
    .wap-cooperation-box .lastText{
        margin-bottom:18px;
    }
</style>
